/* MJD Thread Bar (sample): job tabs, color chart, shop by canvas, color drawer. */
(function () {
  var root = document.getElementById('mtb'); if (!root) return;
  var liveData = JSON.parse(document.getElementById('mtb-live').textContent), live = liveData.p;
  /* Shopify hands Liquid 250 products per page; pull the rest through section rendering */
  function morePages() {
    var reqs = [];
    for (var n = 2; n <= (liveData.pages || 1); n++) {
      var u = new URL(window.location.href); u.searchParams.set('page', n); u.searchParams.set('section_id', liveData.sid);
      reqs.push(fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var m = html.match(/<script type="application\/json" id="mtb-live">([\s\S]*?)<\/script>/);
        if (m) { var d = JSON.parse(m[1]).p; Object.keys(d).forEach(function (k) { live[k] = d[k]; }); }
      }).catch(function () {}));
    }
    return Promise.all(reqs);
  }
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var JOB_NAMES = {};
  $$('.mtb-tab').forEach(function (t) { JOB_NAMES[t.dataset.job] = t.textContent.trim(); });

  var items = [], byKey = {}, chart, fams = [];
  var state = { fam: '', q: '', fmt: '', mesh: '', job: '', line: '', stock: true, canvas: '', sort: 'color' };
  /* brand for products that are not in the chart data, from the product title */
  var EXTRA_BRANDS = [[/neon rays|silk lame|very velvet|stardust|gold rush/i, 'Rainbow Gallery'], [/threadworx/i, 'ThreadworX'], [/radiance/i, 'The Meredith Collection'],
    [/caron/i, 'Caron Collection'], [/tiny starry/i, 'Silk Road Fibers'], [/planet earth/i, 'Planet Earth Fiber'], [/sundance/i, 'Sundance Beads'], [/bead/i, 'MJD Beads']];
  function brandName(m) { return (m || '').replace(/\s*\(.*\)\s*/, '').trim() || 'More Brands'; }

  Promise.all([fetch(root.dataset.chart).then(function (r) { return r.json(); }), morePages()]).then(function (res) {
    var data = res[0];
    chart = data; fams = data.families.concat(['Specialty & Beads']); build(); init();
  }).catch(function () { $('[data-count]').textContent = 'The color chart did not load. Refresh to try again.'; });

  /* the card photo shows the most thread; skein photos are a thin twist, so they get zoomed in */
  function photoOf(formats) {
    var card = formats.filter(function (f) { return f.k === 'card' && live[f.h] && live[f.h].i; })[0];
    if (card) return { src: live[card.h].i, kind: 'card' };
    var sk = formats.filter(function (f) { return f.k === 'skein' && live[f.h] && live[f.h].i; })[0];
    if (sk) return { src: live[sk.h].i.replace(/width=\d+/, 'width=720'), kind: 'skein' };
    var any = formats.filter(function (f) { return live[f.h] && live[f.h].i; })[0];
    return any ? { src: live[any.h].i, kind: 'other' } : null;
  }
  function tagsOf(h) { return (live[h].g || '').split(',').filter(Boolean); }

  function build() {
    var seen = {};
    chart.colors.forEach(function (c) {
      var formats = [];
      ['skein', 'card'].forEach(function (k) {
        var h = c.fo[k]; if (!h || !live[h]) return; seen[h] = 1;
        formats.push({ k: k, label: k === 'card' ? 'Card' : 'Skein', detail: (chart.lines[c.l].formats || {})[k] || '', h: h, v: live[h].v, p: live[h].p, a: live[h].a });
      });
      if (!formats.length) return;
      var tags = [].concat.apply([], formats.map(function (f) { return tagsOf(f.h); }));
      add({ key: c.id, line: c.l, brand: brandName(chart.lines[c.l].maker), lineName: chart.lines[c.l].name, code: c.cc && formats.length === 1 && formats[0].k === 'card' ? c.cc : c.c, name: c.n, hex: c.x, lab: c.lab, fam: c.f,
        img: live[formats[0].h].i, photo: photoOf(formats), canv: c.u || [], formats: formats, tags: tags });
    });
    var lineNeedles = Object.keys(chart.lines).map(function (l) { return [l, chart.lines[l].name.toLowerCase().replace(/ overdyed| \(.*\)/g, '')]; })
      .sort(function (a, b) { return b[1].length - a[1].length; });
    Object.keys(live).forEach(function (h) {
      if (seen[h]) return;
      var p = live[h], t = p.t.replace(/\s+for Needlepoint Canvases/i, '');
      var br = (EXTRA_BRANDS.filter(function (b) { return b[0].test(p.t); })[0] || [0, 'More Brands'])[1];
      var lt = p.t.toLowerCase(), ln = lineNeedles.filter(function (x) { return lt.indexOf(x[1]) > -1; })[0];
      var lid = ln ? ln[0] : 'specialty';
      if (ln) br = brandName(chart.lines[lid].maker);
      add({ key: h, line: lid, brand: br, lineName: ln ? chart.lines[lid].name : 'Specialty', code: '', name: t, hex: null, lab: null, fam: fams.length - 1, img: p.i, canv: [],
        formats: [{ k: 'one', label: 'Each', detail: '', h: h, v: p.v, p: p.p, a: p.a }], tags: tagsOf(h) });
    });
  }
  function add(it) {
    it.jobs = it.tags.filter(function (t, n, all) { return JOB_NAMES[t] && all.indexOf(t) === n; });
    it.mesh = it.tags.filter(function (t) { return /^mesh-/.test(t); }).map(function (t) { return t.slice(5); });
    it.avail = it.formats.some(function (f) { return f.a; });
    it.title = (it.lineName === 'Specialty' ? '' : it.lineName + ' ') + (it.code ? it.code + ' ' : '') + it.name;
    it.search = (it.title + ' ' + it.brand + ' ' + it.formats.map(function (f) { return f.h; }).join(' ')).toLowerCase();
    items.push(it); byKey[it.key] = it;
  }

  /* ---------- chip markup ---------- */
  function chip(it, cls) {
    var ph = it.photo || (it.img ? { src: it.img, kind: 'other' } : null);
    var sw = ph ? '<span class="mtb-chip__sw mtb-chip__sw--img mtb-chip__sw--' + ph.kind + '"' + (it.hex ? ' style="--c:' + it.hex + '"' : '') + '><img src="' + ph.src + '" alt="" loading="lazy"></span>'
      : '<span class="mtb-chip__sw" style="--c:' + it.hex + '"></span>';
    return '<button type="button" class="mtb-chip' + (it.avail ? '' : ' is-out') + (cls ? ' ' + cls : '') + '" data-k="' + esc(it.key) + '" aria-label="' + esc(it.title) + (it.avail ? '' : ', sold out') + '">' + sw +
      '<span class="mtb-chip__c">' + esc(it.code || (it.line === 'specialty' ? it.brand : it.lineName)) + (it.avail ? '' : ' <em>Sold out</em>') + '</span><span class="mtb-chip__n">' + esc(it.name) + '</span></button>';
  }

  /* ---------- init ---------- */
  function init() {
    // family dots
    var counts = fams.map(function (_, i) { return items.filter(function (it) { return it.fam === i; }).length; });
    var rep = fams.map(function (_, i) { var s = items.filter(function (it) { return it.fam === i && it.hex; }); return s.length ? s[Math.floor(s.length / 2)].hex : null; });
    $('[data-fams]').innerHTML = '<button type="button" class="mtb-fam" aria-pressed="true" data-f=""><span class="mtb-fam__dot mtb-fam__dot--all"></span>All</button>' +
      fams.map(function (f, i) { return counts[i] ? '<button type="button" class="mtb-fam" aria-pressed="false" data-f="' + i + '"><span class="mtb-fam__dot' + (rep[i] ? '' : ' mtb-fam__dot--spec') + '" style="--c:' + (rep[i] || 'transparent') + '"></span>' + esc(f.replace(' & ', ' & ')) + '</button>' : ''; }).join('');
    // line select
    var brands = {}; items.forEach(function (it) {
      var b = brands[it.brand] = brands[it.brand] || { n: 0, lines: {} }; b.n++;
      if (it.line !== 'specialty') b.lines[it.line] = (b.lines[it.line] || 0) + 1;
    });
    var lineSel = $('[data-line]');
    Object.keys(brands).sort(function (a, b) { return (a === 'More Brands') - (b === 'More Brands') || a.localeCompare(b); }).forEach(function (b) {
      var o = document.createElement('option'); o.value = 'b:' + b; o.textContent = b + ' (' + brands[b].n + ')'; lineSel.appendChild(o);
      var ls = Object.keys(brands[b].lines);
      if (ls.length > 1) ls.forEach(function (l) { var x = document.createElement('option'); x.value = 'l:' + l; x.textContent = '\u00a0\u00a0\u00a0' + chart.lines[l].name + ' (' + brands[b].lines[l] + ')'; lineSel.appendChild(x); });
    });
    $('[data-sort]').addEventListener('change', function (e) { state.sort = e.target.value; render(); });

    $('[data-fams]').addEventListener('click', function (e) { var b = e.target.closest('[data-f]'); if (!b) return; state.fam = b.dataset.f; pressed($('[data-fams]'), b); render(); });
    seg('[data-fmt]', 'fmt'); seg('[data-mesh]', 'mesh');
    $('[data-q]').addEventListener('input', function (e) { state.q = e.target.value.trim().toLowerCase(); render(); });
    $('[data-job-sel]').addEventListener('change', function (e) { state.job = e.target.value; render(); });
    lineSel.addEventListener('change', function (e) { state.line = e.target.value; render(); });
    $('[data-stock]').addEventListener('change', function (e) { state.stock = e.target.checked; render(); });
    $('[data-reset]').addEventListener('click', reset);
    var more = $('[data-more-filters]');
    more.addEventListener('click', function () { var on = more.getAttribute('aria-expanded') !== 'true'; more.setAttribute('aria-expanded', on); $('.mtb-tools').classList.toggle('is-open', on); });
    $('[data-active]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-clear]'); if (!b) return;
      var k = b.dataset.clear;
      if (k === 'all') { $('[data-cq]').value = ''; reset(); return; }
      if (k === 'canvas') { state.canvas = ''; $('[data-cq]').value = ''; }
      if (k === 'job') { state.job = ''; $('[data-job-sel]').value = ''; }
      if (k === 'fam') { state.fam = ''; pressed($('[data-fams]'), $('[data-fams] [data-f=""]')); }
      if (k === 'line') { state.line = ''; $('[data-line]').value = ''; }
      if (k === 'fmt') { state.fmt = ''; pressed($('[data-fmt]'), $('[data-fmt] [data-v=""]')); }
      if (k === 'mesh') { state.mesh = ''; pressed($('[data-mesh]'), $('[data-mesh] [data-v=""]')); }
      if (k === 'q') { state.q = ''; $('[data-q]').value = ''; }
      if (k === 'stock') { state.stock = true; $('[data-stock]').checked = true; }
      render();
    });
    root.addEventListener('click', function (e) {
      var c = e.target.closest('.mtb-chip'); if (c) { openDrawer(byKey[c.dataset.k]); return; }
      var s = e.target.closest('[data-see-all]'); if (s && root.dataset.gridUrl) { goGrid(s.dataset.seeAll); return; }
      if (s) { reset(true); state.job = s.dataset.seeAll; $('[data-job-sel]').value = state.job; render(); jump('#mtb-chart'); }
    });

    root.addEventListener('click', function (e) { var g = e.target.closest('.mtb-line'); if (g) applyGroup(g); });
    jobs(); estimator(); canvases(); picker(); drawerEvents(); render();
  }
  function pressed(group, btn) { $$('[aria-pressed]', group).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); }); }
  function seg(sel, key) {
    var g = $(sel); g.addEventListener('click', function (e) { var b = e.target.closest('[data-v]'); if (!b) return; state[key] = b.dataset.v; pressed(g, b); render(); });
  }
  function reset(silent) {
    state = { fam: '', q: '', fmt: '', mesh: '', job: '', line: '', stock: true, canvas: '', sort: state.sort, target: state.target };
    $('[data-q]').value = ''; $('[data-job-sel]').value = ''; $('[data-line]').value = ''; $('[data-stock]').checked = true;
    ['[data-fams]', '[data-fmt]', '[data-mesh]'].forEach(function (s) { pressed($(s), $(s).querySelector('[aria-pressed]')); });
    if (silent !== true) render();
  }
  function jump(sel) {
    var el = $(sel), hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mjd-hdr')) || 0;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - hdr - 12, behavior: 'smooth' });
  }

  /* ---------- chart ---------- */
  function match(it) {
    if (state.fam !== '' && it.fam !== +state.fam) return false;
    if (state.q && it.search.indexOf(state.q) < 0) return false;
    if (state.fmt && !it.formats.some(function (f) { return f.k === state.fmt; })) return false;
    if (state.mesh && it.mesh.indexOf(state.mesh) < 0) return false;
    if (state.job && it.jobs.indexOf(state.job) < 0) return false;
    if (state.line && (state.line.slice(0, 2) === 'b:' ? it.brand !== state.line.slice(2) : it.line !== state.line.slice(2))) return false;
    if (state.stock && !it.avail) return false;
    if (state.canvas && it.canv.indexOf(state.canvas) < 0) return false;
    return true;
  }
  function render() {
    var list = items.filter(match), grid = $('[data-grid]');
    $('[data-count]').textContent = list.length + (list.length === 1 ? ' thread' : ' threads');
    $('[data-empty]').hidden = list.length > 0;
    /* every active filter shows as a chip you can remove, plus Clear all */
    var act = $('[data-active]'), pills = [];
    var pill = function (key, label) { return '<span class="mtb-pill">' + label + '<button type="button" data-clear="' + key + '" aria-label="Remove filter">&times;</button></span>'; };
    if (state.canvas) pills.push(pill('canvas', 'Threads for <strong>' + esc(chart.canvases[state.canvas].t) + '</strong>'));
    if (state.job) pills.push(pill('job', esc(JOB_NAMES[state.job] || state.job)));
    if (state.fam !== '') pills.push(pill('fam', esc(fams[+state.fam])));
    if (state.line) pills.push(pill('line', esc($('[data-line] option[value="' + state.line.replace(/"/g, '\\"') + '"]') ? $('[data-line] option[value="' + state.line.replace(/"/g, '\\"') + '"]').textContent.replace(/\s*\(\d+\)\s*$/, '').trim() : state.line.slice(2))));
    if (state.fmt) pills.push(pill('fmt', state.fmt === 'card' ? 'Cards' : 'Skeins'));
    if (state.mesh) pills.push(pill('mesh', state.mesh + ' mesh'));
    if (state.q) pills.push(pill('q', '“' + esc(state.q) + '”'));
    if (!state.stock) pills.push(pill('stock', 'Including sold out'));
    act.hidden = !pills.length;
    act.innerHTML = pills.join('') + (pills.length ? '<button class="mjd-link mtb-clearall" type="button" data-clear="all">Clear all</button>' : '') +
      (state.canvas ? '<a class="mjd-link" href="/products/' + state.canvas + '">Shop the canvas</a>' : '');
    var num = function (it) { return parseInt(String(it.code).replace(/\D/g, ''), 10) || 1e9; };
    if (state.sort === 'near' && state.target) list.sort(function (a, b) { return (a.lab ? dist(a.lab, state.target) : 1e9) - (b.lab ? dist(b.lab, state.target) : 1e9); });
    if (state.sort === 'number') list.sort(function (a, b) { return a.brand.localeCompare(b.brand) || a.lineName.localeCompare(b.lineName) || num(a) - num(b); });
    if (state.sort === 'name') list.sort(function (a, b) { return a.name.localeCompare(b.name); });
    if (state.sort === 'brand') list.sort(function (a, b) { return (a.brand === 'More Brands') - (b.brand === 'More Brands') || a.brand.localeCompare(b.brand) || a.lineName.localeCompare(b.lineName) || a.fam - b.fam; });
    var groups = [];
    if (state.sort === 'brand' && !state.canvas) {
      list.forEach(function (it) { var g = groups[groups.length - 1]; if (!g || g.k !== it.brand) groups.push(g = { k: it.brand, items: [] }); g.items.push(it); });
    } else if (state.sort === 'color' && state.fam === '' && !state.q && !state.canvas) {
      fams.forEach(function (f, i) { var g = list.filter(function (it) { return it.fam === i; }); if (g.length) groups.push({ k: f, items: g }); });
    }
    if (!groups.length) { grid.innerHTML = '<div class="mtb-chart__grid">' + list.map(function (it) { return chip(it); }).join('') + '</div>'; return; }
    grid.innerHTML = groups.map(function (g) {
      return '<div class="mtb-chart__fam"><h3 class="mtb-chart__h">' + esc(g.k) + ' <span>' + g.items.length + '</span></h3><div class="mtb-chart__grid">' + g.items.map(function (it) { return chip(it); }).join('') + '</div></div>';
    }).join('');
  }

  /* ---------- job tabs + picks ---------- */
  function jobs() {
    var tabs = $$('.mtb-tab');
    /* circles open and close their panel; everything starts closed */
    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { toggle(t.getAttribute('aria-expanded') === 'true' ? -1 : n); });
    });
    $$('[data-panel-close]').forEach(function (x) { x.addEventListener('click', function () { var n = $$('.mtb-panel').indexOf(x.closest('.mtb-panel')); toggle(-1); tabs[n].focus(); }); });
    function toggle(n) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-expanded', k === n ? 'true' : 'false'); });
      $$('.mtb-panel').forEach(function (p, k) { p.hidden = k !== n; });
    }
    /* "Threads in this group": every thread line tagged for this use, linked to the grid below
       filtered by Thread Brand (lines without a Thread Brand value yet show as plain text) */
    var brandVals = [].map.call(document.querySelectorAll('.mjc-filters input[name="filter.p.m.custom.thread_brand"]'), function (i) { return i.value; });
    $$('[data-threads-for]').forEach(function (box) {
      var job = box.dataset.threadsFor, counts = {};
      items.forEach(function (it) {
        if (!it.avail || it.jobs.indexOf(job) < 0) return;
        var name = it.line === 'specialty' ? it.brand : it.lineName.replace(/ Overdyed$/, '');
        if (name === 'More Brands') return;
        counts[name] = (counts[name] || 0) + 1;
      });
      var names = Object.keys(counts).sort(function (x, y) { return counts[y] - counts[x]; });
      if (!names.length) return;
      box.querySelector('ul').innerHTML = names.map(function (n) {
        var bv = brandVals.filter(function (v) { return v.toLowerCase() === n.toLowerCase(); })[0];
        return '<li>' + (bv ? '<a href="' + gridLink(job, bv) + '" data-thread-link="' + esc(bv) + '" data-thread-job="' + job + '">' + esc(n) + '</a>' : esc(n)) + '</li>';
      }).join('');
      box.hidden = false;
    });
    root.addEventListener('click', function (e) {
      var l = e.target.closest('[data-thread-link]'); if (!l) return;
      e.preventDefault(); goGrid(l.dataset.threadJob, l.dataset.threadLink);
    });
    $$('[data-opts]').forEach(function (box) {
      var job = box.dataset.opts;
      var gs = groupsOf(items.filter(function (it) { return it.jobs.indexOf(job) > -1; })).filter(function (g) { return g.inStock; });
      gs.sort(function (a, b) { return ((job === 'backgrounds' && b.fk === 'skein') - (job === 'backgrounds' && a.fk === 'skein')) || b.n - a.n; });
      box.innerHTML = gs.length ? '<p class="mtb-opts__h">' + (gs.length > 1 ? 'Your options, side by side' : 'The thread for this') + '</p><div class="mtb-opts__grid mtb-opts__grid--' + Math.min(gs.length, 4) + '">' +
        gs.slice(0, 4).map(function (g) { return lineCard(g, job); }).join('') + '</div>' : '<p class="mtb-opts__h">Restocking soon</p>';
    });
  }

  /* ---------- thread lines (real photos) ---------- */
  var bothFormats = null;
  function groupsOf(list) {
    if (!bothFormats) {
      /* only split a line into Cards vs Skeins when we sell it both ways */
      var seen = {}; bothFormats = {};
      items.forEach(function (it) { it.formats.forEach(function (f) { (seen[it.line] = seen[it.line] || {})[f.k] = 1; }); });
      Object.keys(seen).forEach(function (l) { bothFormats[l] = seen[l].card && seen[l].skein; });
    }
    var g = {}, order = [];
    list.forEach(function (it) {
      var base = it.line === 'specialty' ? 'b:' + it.brand : 'l:' + it.line;
      var split = it.line !== 'specialty' && bothFormats[it.line];
      (split ? it.formats : [it.formats[0]]).forEach(function (f) {
        var fk = split && (f.k === 'card' || f.k === 'skein') ? f.k : '';
        var key = base + '|' + fk, x = g[key];
        if (!x) {
          x = g[key] = { key: key, filter: base, fk: fk, brand: it.brand, detail: f.detail, n: 0, inStock: 0, min: Infinity, img: '', score: -1,
            name: (it.line === 'specialty' ? it.brand : it.lineName) + (fk === 'card' ? ' Cards' : fk === 'skein' ? ' Skeins' : '') };
          order.push(key);
        }
        x.n++; x.one = it;
        if (f.a) {
          x.inStock++; x.min = Math.min(x.min, f.p);
          /* show a colorful, mid-tone thread so the photo reads (not white on white) */
          var img = live[f.h] && live[f.h].i, L = it.lab ? it.lab[0] : 0;
          var sc = it.lab ? (L > 35 && L < 78 ? Math.hypot(it.lab[1], it.lab[2]) : 0) + it.canv.length : it.canv.length;
          if (img && sc > x.score) { x.score = sc; x.img = img; }
        }
        if (!x.img && live[f.h] && live[f.h].i) x.img = live[f.h].i;
      });
    });
    return order.map(function (k) {
      var x = g[k];
      /* a one-off specialty product reads better under its own name than its brand */
      if (x.n === 1 && x.filter.slice(0, 2) === 'b:') x.name = x.one.name.split(' - ')[0].replace(/^Planet Earth /, '');
      return x;
    });
  }
  function lineCard(g, job) {
    return '<button type="button" class="mtb-line" data-group="' + esc(g.filter) + '" data-gfmt="' + g.fk + '" data-gjob="' + (job || '') + '" data-gbrand="' + esc(g.brand) + '">' +
      '<span class="mtb-line__img' + (g.fk === 'skein' ? ' mtb-line__img--skein' : '') + '">' + (g.img ? '<img src="' + g.img + '" alt="' + esc(g.name) + '" loading="lazy">' : '') + '</span>' +
      '<span class="mtb-line__b">' + esc(g.brand) + '</span><span class="mtb-line__t">' + esc(g.name) + '</span>' +
      '<span class="mtb-line__d">' + [g.detail, g.min < Infinity ? 'from ' + money(g.min) : ''].filter(Boolean).join(' · ') + '</span>' +
      '<span class="mtb-line__n">See ' + g.n + (g.n === 1 ? ' color' : ' colors') + '</span></button>';
  }
  /* on Morgan's page there is no chart: send people to her thread grid filtered by that use */
  function gridLink(job, brand) {
    var u = root.dataset.gridUrl + (job ? '+tb-' + job : '') + (root.dataset.gridSuffix || '');
    if (brand) u += (u.indexOf('?') > -1 ? '&' : '?') + 'filter.p.m.custom.thread_brand=' + encodeURIComponent(brand);
    return u;
  }
  /* filter the thread grid on this page in place (no reload) and scroll down to it */
  function goGrid(job, brand) {
    var grid = document.querySelector('.mjc[data-section]');
    if (!grid) { location.href = gridLink(job, brand); return; }
    var a = document.createElement('a'); a.href = gridLink(job, brand); a.setAttribute('data-nav', ''); a.hidden = true;
    var res = grid.querySelector('[data-mjc-results]');
    function scrollDown() {
      var hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mjd-hdr')) || 110;
      var target = res.querySelector('.mjc-use') || grid;
      var bar = grid.querySelector('.mjc__bar'), barH = bar ? bar.getBoundingClientRect().height : 0;
      var off = hdr + barH + 16;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
      /* if the smooth scroll got interrupted (images still loading, focus moves), jump there */
      setTimeout(function () {
        var t = res.querySelector('.mjc-use') || grid;
        if (Math.abs(t.getBoundingClientRect().top - off) > 60) window.scrollTo(0, t.getBoundingClientRect().top + window.pageYOffset - off);
      }, 900);
    }
    /* scroll once the filtered results have been swapped in */
    if (res && window.MutationObserver) {
      var mo = new MutationObserver(function () { mo.disconnect(); setTimeout(scrollDown, 60); });
      mo.observe(res, { childList: true });
      setTimeout(function () { mo.disconnect(); }, 8000);
    }
    grid.appendChild(a); a.click(); a.remove();
    scrollDown();
  }
  function applyGroup(b) {
    if (root.dataset.gridUrl) { goGrid(b.dataset.gjob); return; }
    reset(true);
    var sel = $('[data-line]'), want = b.dataset.group;
    if (![].some.call(sel.options, function (o) { return o.value === want; })) want = 'b:' + b.dataset.gbrand;
    state.line = want; sel.value = want;
    state.fmt = b.dataset.gfmt; pressed($('[data-fmt]'), $('[data-fmt] [data-v="' + state.fmt + '"]'));
    if (b.dataset.gjob) { state.job = b.dataset.gjob; $('[data-job-sel]').value = state.job; }
    render(); jump('#mtb-chart');
  }

  /* ---------- color picker ---------- */
  function hex2rgb(h) { h = h.replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); var n = parseInt(h, 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
  function rgb2hex(c) { return '#' + c.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); }
  function hsv2rgb(h, s, v) {
    var f = function (n) { var k = (n + h / 60) % 6; return 255 * (v - v * s * Math.max(0, Math.min(k, 4 - k, 1))); };
    return [f(5), f(3), f(1)];
  }
  function rgb2hsv(c) {
    var r = c[0] / 255, g = c[1] / 255, b = c[2] / 255, mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, h = 0;
    if (d) h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
    return [(h * 60 + 360) % 360, mx ? d / mx : 0, mx];
  }
  function rgb2lab(c) {
    var l = c.map(function (v) { v /= 255; return v > 0.04045 ? Math.pow((v + 0.055) / 1.055, 2.4) : v / 12.92; });
    var x = (l[0] * 0.4124 + l[1] * 0.3576 + l[2] * 0.1805) / 0.95047, y = l[0] * 0.2126 + l[1] * 0.7152 + l[2] * 0.0722, z = (l[0] * 0.0193 + l[1] * 0.1192 + l[2] * 0.9505) / 1.08883;
    var f = function (t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; };
    return [116 * f(y) - 16, 500 * (f(x) - f(y)), 200 * (f(y) - f(z))];
  }
  function dist(a, b) { return Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]); }
  function picker() {
    var box = $('[data-picker]'), sv = $('[data-sv]', box), knob = $('[data-knob]', box), hue = $('[data-hue]', box), hexIn = $('[data-hex]', box);
    var hsv = rgb2hsv(hex2rgb(hexIn.value)), raf = 0;
    function update(fromHex) {
      var rgb = hsv2rgb(hsv[0], hsv[1], hsv[2]), hex = rgb2hex(rgb);
      sv.style.setProperty('--h', hsv[0]); hue.value = Math.round(hsv[0]);
      knob.style.left = (hsv[1] * 100) + '%'; knob.style.top = ((1 - hsv[2]) * 100) + '%'; knob.style.background = hex;
      $('[data-dot]', box).style.background = hex; sv.setAttribute('aria-valuetext', hex);
      if (!fromHex) hexIn.value = hex;
      state.target = rgb2lab(rgb);
      clearTimeout(raf); raf = setTimeout(matches, 30);
    }
    function matches() {
      var t = state.target;
      var near = items.filter(function (it) { return it.lab && (it.avail || !state.stock); })
        .map(function (it) { return { it: it, d: dist(it.lab, t) }; }).sort(function (a, b) { return a.d - b.d; }).slice(0, 8);
      $('[data-matches]', box).innerHTML = near.map(function (x) { return chip(x.it, 'mtb-chip--mini'); }).join('');
      if (state.sort === 'near') render();
    }
    function fromPoint(e) {
      var r = sv.getBoundingClientRect();
      hsv[1] = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)); hsv[2] = 1 - Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)); update();
    }
    sv.addEventListener('pointerdown', function (e) { sv.setPointerCapture(e.pointerId); fromPoint(e); });
    sv.addEventListener('pointermove', function (e) { if (sv.hasPointerCapture(e.pointerId)) fromPoint(e); });
    sv.addEventListener('keydown', function (e) {
      var d = { ArrowLeft: [-0.03, 0], ArrowRight: [0.03, 0], ArrowUp: [0, 0.03], ArrowDown: [0, -0.03] }[e.key]; if (!d) return;
      e.preventDefault(); hsv[1] = Math.min(1, Math.max(0, hsv[1] + d[0])); hsv[2] = Math.min(1, Math.max(0, hsv[2] + d[1])); update();
    });
    hue.addEventListener('input', function () { hsv[0] = +hue.value; update(); });
    hexIn.addEventListener('input', function () {
      var v = hexIn.value.trim(); if (v[0] !== '#') v = '#' + v;
      if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v)) { hsv = rgb2hsv(hex2rgb(v)); update(true); }
    });
    hexIn.addEventListener('blur', function () { update(); });
    var eye = $('[data-eye]', box);
    if ('EyeDropper' in window) {
      eye.hidden = false;
      eye.addEventListener('click', function () { new window.EyeDropper().open().then(function (r) { hsv = rgb2hsv(hex2rgb(r.sRGBHex)); update(); }).catch(function () {}); });
    }
    $('[data-sort-near]', box).addEventListener('click', function () {
      var so = $('[data-sort]'), opt = $('[data-near-opt]'); opt.hidden = false;
      state.sort = 'near'; so.value = 'near'; state.fam = ''; pressed($('[data-fams]'), $('[data-fams] [data-f=""]')); render();
      var bar = $('[data-bar]'); bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    $('[data-stock]').addEventListener('change', matches);

    /* match from a photo: an MJD canvas or the shopper's own upload, tap a spot to sample it */
    var cv = $('[data-pk-cv]', box), photo = $('[data-pk-photo]', box), pin = $('[data-pk-pin]', box), tip = $('[data-pk-tip]', box), csel = $('[data-pk-canvas]', box);
    Object.keys(chart.canvases).sort(function (a, b) { return chart.canvases[a].t.localeCompare(chart.canvases[b].t); }).forEach(function (h) {
      var o = document.createElement('option'); o.value = h; o.textContent = chart.canvases[h].t; csel.appendChild(o);
    });
    function draw(src, local) {
      var img = new Image();
      if (!local) img.crossOrigin = 'anonymous';
      img.onload = function () {
        var w = Math.min(900, img.naturalWidth), h = Math.round(img.naturalHeight * w / img.naturalWidth);
        cv.width = w; cv.height = h; cv.getContext('2d').drawImage(img, 0, 0, w, h);
        photo.hidden = false; tip.hidden = false; pin.hidden = true; tip.textContent = 'Tap any spot on the photo to find threads that match it.';
        if (local) URL.revokeObjectURL(src);
      };
      img.onerror = function () { photo.hidden = true; tip.hidden = false; tip.textContent = 'That photo did not load. Try another one.'; };
      img.src = src;
    }
    csel.addEventListener('change', function () {
      var c = chart.canvases[csel.value]; if (!c) return;
      /* same-origin copy of the CDN image so the canvas can be read */
      var src = c.i.replace(/^https:\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/files\//, '/cdn/shop/files/').replace(/width=\d+/, 'width=900');
      draw(src, false);
    });
    $('[data-pk-file]', box).addEventListener('change', function (e) { var f = e.target.files[0]; if (f) { csel.value = ''; draw(URL.createObjectURL(f), true); } });
    $('[data-pk-clear]', box).addEventListener('click', function () {
      photo.hidden = true; tip.hidden = true; pin.hidden = true; csel.value = ''; $('[data-pk-file]', box).value = '';
      cv.getContext('2d').clearRect(0, 0, cv.width, cv.height);
    });
    cv.addEventListener('click', function (e) {
      var r = cv.getBoundingClientRect(), x = Math.round((e.clientX - r.left) * cv.width / r.width), y = Math.round((e.clientY - r.top) * cv.height / r.height);
      try {
        var d = cv.getContext('2d').getImageData(Math.max(0, x - 3), Math.max(0, y - 3), 7, 7).data, sum = [0, 0, 0], n = 0;
        for (var i = 0; i < d.length; i += 4) { if (d[i + 3] < 128) continue; sum[0] += d[i]; sum[1] += d[i + 1]; sum[2] += d[i + 2]; n++; }
        if (!n) return;
        hsv = rgb2hsv(sum.map(function (v) { return v / n; })); update();
        pin.hidden = false; pin.style.left = (e.clientX - r.left) + 'px'; pin.style.top = (e.clientY - r.top) + 'px'; pin.style.background = hexIn.value;
      } catch (err) { tip.textContent = 'This photo cannot be color-matched here. Upload a photo instead.'; }
    });
    update();
  }

  /* ---------- estimator ---------- */
  function estimator() {
    $$('[data-est]').forEach(function (box) {
      function calc() {
        var w = parseFloat($('[data-w]', box).value) || 0, h = parseFloat($('[data-h]', box).value) || 0, m = $('[data-m]', box).value;
        var yd = Math.ceil(w * h * (m === '18' ? 1.35 : 1) * 1.15);
        $('[data-out]', box).innerHTML = yd ? 'About <strong>' + yd + ' yards</strong>: ' + Math.ceil(yd / 30) + ' skein' + (Math.ceil(yd / 30) > 1 ? 's' : '') + ' or ' + Math.ceil(yd / 10) + ' cards.' : '';
      }
      box.addEventListener('input', calc); calc();
    });
  }

  /* ---------- canvases ---------- */
  function canvases() {
    var count = {};
    items.forEach(function (it) { it.canv.forEach(function (c) { count[c] = (count[c] || 0) + 1; }); });
    var list = Object.keys(count).filter(function (h) { return chart.canvases[h]; });
    var input = $('[data-cq]'), res = $('[data-cres]'), active = -1;
    function close() { res.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function show() {
      var q = input.value.trim().toLowerCase();
      if (!q) { close(); return; }
      var hits = list.filter(function (h) { return chart.canvases[h].t.toLowerCase().indexOf(q) > -1; }).slice(0, 6);
      res.innerHTML = hits.length ? hits.map(function (h, n) {
        var c = chart.canvases[h];
        return '<li role="option" id="mtb-co-' + n + '" data-cv="' + h + '"><img src="' + c.i + '" alt="" loading="lazy"><span>' + esc(c.t) + '<em>' + count[h] + ' thread' + (count[h] > 1 ? 's' : '') + '</em></span></li>';
      }).join('') : '<li class="mtb-look__none">No canvas with a thread list matches that yet.</li>';
      res.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
    }
    function pick(h) {
      close(); input.value = chart.canvases[h].t;
      reset(true); input.value = chart.canvases[h].t;
      state.canvas = h; state.stock = false; $('[data-stock]').checked = false; render();
      $('[data-grid]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    input.addEventListener('input', show);
    input.addEventListener('focus', show);
    input.addEventListener('keydown', function (e) {
      var opts = $$('[data-cv]', res);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (!opts.length) return;
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, n) { o.classList.toggle('is-active', n === active); });
        input.setAttribute('aria-activedescendant', opts[active].id);
      } else if (e.key === 'Enter') { e.preventDefault(); var o = opts[active > -1 ? active : 0]; if (o) pick(o.dataset.cv); }
      else if (e.key === 'Escape') close();
    });
    res.addEventListener('mousedown', function (e) { var o = e.target.closest('[data-cv]'); if (o) { e.preventDefault(); pick(o.dataset.cv); } });
    input.addEventListener('blur', function () { setTimeout(close, 120); });
  }

  /* ---------- drawer ---------- */
  var drawer = $('[data-drawer]'), lastFocus = null;
  function drawerEvents() {
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });
  }
  function near(it) {
    if (!it.lab) return [];
    return items.filter(function (o) { return o !== it && o.lab; }).map(function (o) {
      var d = Math.hypot(o.lab[0] - it.lab[0], o.lab[1] - it.lab[1], o.lab[2] - it.lab[2]); return { o: o, d: d };
    }).sort(function (a, b) { return a.d - b.d; }).slice(0, 8).map(function (x) { return x.o; });
  }
  function openDrawer(it) {
    if (!it) return;
    lastFocus = document.activeElement;
    var first = it.formats.filter(function (f) { return f.a; })[0] || it.formats[0];
    var line = chart.lines[it.line];
    var cv = it.canv.filter(function (h) { return chart.canvases[h]; });
    var close = near(it);
    var html = '<div class="mtb-d__top">' +
      (it.img || it.photo ? '<figure class="mtb-d__photo mtb-d__photo--main"><img src="' + (it.photo ? it.photo.src : it.img).replace(/width=\d+/, 'width=900') + '" alt="' + esc(it.title) + '"></figure>' : '') +
      (it.hex ? '<figure class="mtb-d__photo"><span class="mtb-d__sw" style="--c:' + it.hex + '" role="img" aria-label="Color on screen"></span><figcaption>Color on screen</figcaption></figure>' : '') +
      '</div>' +
      '<p class="mtb-eyebrow">' + esc(it.brand + (it.lineName !== 'Specialty' ? ' \u00b7 ' + it.lineName : '')) + '</p><h2 class="mtb-d__t" id="mtb-d-title">' + esc((it.code ? it.code + ' ' : '') + it.name) + '</h2>' +
      (line ? '<p class="mtb-d__meta">' + esc([line.fiber, line.mesh].filter(Boolean).join(' · ')) + '</p>' : '') +
      (it.jobs.length ? '<p class="mtb-d__jobs">' + it.jobs.map(function (j) { return '<span>' + esc(JOB_NAMES[j]) + '</span>'; }).join('') + '</p>' : '') +
      '<fieldset class="mtb-d__fmts"><legend class="mjd-sr">Choose a format</legend>' + it.formats.map(function (f) {
        return '<label class="mtb-fmt' + (f.a ? '' : ' is-out') + '"><input type="radio" name="mtb-fmt" value="' + f.v + '" data-h="' + f.h + '"' + (f === first ? ' checked' : '') + (f.a ? '' : ' disabled') + '>' +
          '<span class="mtb-fmt__l"><strong>' + f.label + '</strong>' + (f.detail ? '<span>' + f.detail + '</span>' : '') + '</span><span class="mtb-fmt__p">' + (f.a ? money(f.p) : 'Sold out') + '</span></label>';
      }).join('') + '</fieldset>' +
      (it.formats.length > 1 ? '<p class="mtb-d__hint">Cards are perfect for small details. Grab skeins for backgrounds and big areas.</p>' : '') +
      (it.avail
        ? '<div class="mtb-d__buy"><div class="mtb-qty"><button type="button" data-step="-1" aria-label="Fewer">−</button><input type="number" min="1" max="99" value="1" aria-label="Quantity" data-qty><button type="button" data-step="1" aria-label="More">+</button></div><button class="mjd-btn" type="button" data-add>Add to Bag</button></div><p class="mtb-d__msg" data-msg aria-live="polite"></p>'
        : '<a class="mjd-btn mjd-btn--ghost mtb-d__notify" href="/products/' + first.h + '">Get notified when it’s back</a>') +
      (cv.length ? '<div class="mtb-d__sec"><p class="mtb-d__h">Morgan stitched it in</p><div class="mtb-d__cvs">' + cv.slice(0, 6).map(function (h) {
        var c = chart.canvases[h]; return '<a href="/products/' + h + '"><img src="' + c.i + '" alt="" loading="lazy"><span>' + esc(c.t) + '</span></a>';
      }).join('') + '</div></div>' : '') +
      (close.length ? '<div class="mtb-d__sec"><p class="mtb-d__h">Close shades</p><div class="mtb-d__near">' + close.map(function (o) { return chip(o, 'mtb-chip--mini'); }).join('') + '</div></div>' : '') +
      '<a class="mjd-link mtb-d__more" href="/products/' + first.h + '">Full product details</a>';
    $('[data-body]', drawer).innerHTML = html;
    drawer.hidden = false; document.documentElement.classList.add('mtb-lock');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); $('.mtb-drawer__panel', drawer).focus(); $('.mtb-drawer__panel', drawer).scrollTop = 0; });
    var qty = $('[data-qty]', drawer);
    $$('[data-step]', drawer).forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(99, (+qty.value || 1) + +b.dataset.step)); }); });
    var addBtn = $('[data-add]', drawer);
    if (addBtn) addBtn.addEventListener('click', function () {
      var r = $('input[name=mtb-fmt]:checked', drawer); if (!r) return;
      addBtn.disabled = true; addBtn.textContent = 'Adding';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +r.value, quantity: +qty.value || 1 }] })
      }).then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; }); })
        .then(function () { addBtn.textContent = 'Added'; $('[data-msg]', drawer).textContent = 'In your bag.'; closeDrawer(); return refreshCart(); })
        .catch(function (err) { $('[data-msg]', drawer).textContent = (err && err.description) || 'That did not go through. Try again?'; })
        .then(function () { setTimeout(function () { addBtn.disabled = false; addBtn.textContent = 'Add to Bag'; }, 900); });
    });
  }
  function closeDrawer() {
    drawer.classList.remove('is-open'); document.documentElement.classList.remove('mtb-lock');
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function refreshCart() {
    /* the store's cart drawer is the UpCart app; the cart count bubble and /cart are fallbacks */
    if (typeof window.upcartRefreshCart === 'function') {
      return Promise.resolve(window.upcartRefreshCart()).then(function () { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); });
    }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var b = document.querySelector('#cart-icon-bubble'); if (b) b.setAttribute('data-count', c.item_count);
    });
  }
})();
